var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.706 12.707c.39-.391.39-1.025 0-1.416l-5-5a1.002 1.002 0 0 0-1.415 1.416L15.588 11H6a.999.999 0 1 0 0 2h9.584l-3.29 3.294a1.002 1.002 0 0 0 1.415 1.416l5-5z"
  })));
};
export default SvgArrowRight;